<script lang="ts">
    import { _ } from "svelte-i18n";

    export let filteredCount: number = 0;
    export let totalCount: number = 0;
</script>


<div class="info">
    <div class="bold">{filteredCount}</div>
    <div class="lite">({$_('from')} {totalCount})</div>
</div>

<style>
    .info {
        display: flex;
        flex-direction: row;
        column-gap: 5px;
        /*color: var(--automapa-blue);*/
        opacity: 0.78;
        align-items: baseline;
        min-width: 120px;
    }
    .bold {
        font-weight: 500;
        font-size: 16px;
    }
    .lite {
        font-weight: 300;
        opacity: 0.5;
    }
</style>